import { GlSkeletonLoader } from '@gitlab/ui';
export default {
    name: 'LoadingStateListItem',
    components: {
        GlSkeletonLoader
    },
    props: {
        leftLinesCount: {
            type: Number,
            required: false,
            default: 2
        },
        rightLinesCount: {
            type: Number,
            required: false,
            default: 2
        }
    }
};
